import { s as script$1 } from './Icon-fJqkx1gN.js';
import { resolveComponent, openBlock, createElementBlock, createElementVNode, normalizeClass, createBlock, createCommentVNode, renderSlot, withKeys, withModifiers } from 'vue';

var script = {
    name: 'BTag',
    components: {
        [script$1.name]: script$1
    },
    props: {
        attached: Boolean,
        closable: Boolean,
        type: [String, Object],
        size: String,
        rounded: Boolean,
        disabled: Boolean,
        ellipsis: Boolean,
        tabstop: {
            type: Boolean,
            default: true
        },
        ariaCloseLabel: String,
        icon: String,
        iconType: String,
        iconPack: String,
        closeType: String,
        closeIcon: String,
        closeIconPack: String,
        closeIconType: String
    },
    emits: ['click', 'close'],
    computed: {
        // setting a boolean attribute `false` does not remove it on Vue 3.
        // `null` or `undefined` has to be given to remove it.
        disabledOrUndefined() {
            return this.disabled || undefined
        }
    },
    methods: {
        /**
        * Emit close event when delete button is clicked
        * or delete key is pressed.
        */
        close(event) {
            if (this.disabled) return

            this.$emit('close', event);
        },
        /**
        * Emit click event when tag is clicked.
        */
        click(event) {
            if (this.disabled) return

            this.$emit('click', event);
        }
    }
};

const _hoisted_1 = {
  key: 0,
  class: "tags has-addons inline-tags"
};
const _hoisted_2 = ["aria-label", "tabindex", "disabled"];
const _hoisted_3 = ["aria-label", "disabled", "tabindex"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = resolveComponent("b-icon");

  return ($props.attached && $props.closable)
    ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("span", {
          class: normalizeClass(["tag", [$props.type, $props.size, { 'is-rounded': $props.rounded }]])
        }, [
          ($props.icon)
            ? (openBlock(), createBlock(_component_b_icon, {
                key: 0,
                icon: $props.icon,
                size: $props.size,
                type: $props.iconType,
                pack: $props.iconPack
              }, null, 8 /* PROPS */, ["icon", "size", "type", "pack"]))
            : createCommentVNode("v-if", true),
          createElementVNode("span", {
            class: normalizeClass({ 'has-ellipsis': $props.ellipsis }),
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.click && $options.click(...args)))
          }, [
            renderSlot(_ctx.$slots, "default")
          ], 2 /* CLASS */)
        ], 2 /* CLASS */),
        createElementVNode("a", {
          class: normalizeClass(["tag", [$props.size,
                     $props.closeType,
                     {'is-rounded': $props.rounded},
                     $props.closeIcon ? 'has-delete-icon' : 'is-delete']]),
          role: "button",
          "aria-label": $props.ariaCloseLabel,
          tabindex: $props.tabstop ? 0 : false,
          disabled: $options.disabledOrUndefined,
          onClick: _cache[1] || (_cache[1] = (...args) => ($options.close && $options.close(...args))),
          onKeyup: _cache[2] || (_cache[2] = withKeys(withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"]), ["delete"]))
        }, [
          ($props.closeIcon)
            ? (openBlock(), createBlock(_component_b_icon, {
                key: 0,
                "custom-class": "",
                icon: $props.closeIcon,
                size: $props.size,
                type: $props.closeIconType,
                pack: $props.closeIconPack
              }, null, 8 /* PROPS */, ["icon", "size", "type", "pack"]))
            : createCommentVNode("v-if", true)
        ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_2)
      ]))
    : (openBlock(), createElementBlock("span", {
        key: 1,
        class: normalizeClass(["tag", [$props.type, $props.size, { 'is-rounded': $props.rounded }]])
      }, [
        ($props.icon)
          ? (openBlock(), createBlock(_component_b_icon, {
              key: 0,
              icon: $props.icon,
              size: $props.size,
              type: $props.iconType,
              pack: $props.iconPack
            }, null, 8 /* PROPS */, ["icon", "size", "type", "pack"]))
          : createCommentVNode("v-if", true),
        createElementVNode("span", {
          class: normalizeClass({ 'has-ellipsis': $props.ellipsis }),
          onClick: _cache[3] || (_cache[3] = (...args) => ($options.click && $options.click(...args)))
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */),
        ($props.closable)
          ? (openBlock(), createElementBlock("a", {
              key: 1,
              role: "button",
              "aria-label": $props.ariaCloseLabel,
              class: normalizeClass(["delete is-small", $props.closeType]),
              disabled: $options.disabledOrUndefined,
              tabindex: $props.tabstop ? 0 : false,
              onClick: _cache[4] || (_cache[4] = (...args) => ($options.close && $options.close(...args))),
              onKeyup: _cache[5] || (_cache[5] = withKeys(withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"]), ["delete"]))
            }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_3))
          : createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
}

script.render = render;
script.__file = "src/components/tag/Tag.vue";

export { script as s };
